<template>
<div class="ds-wrap">
  <button class="btn btn-sm btn-outline-warning" @click="toggleMain"><i class="mdi mdi-share-variant me-1"></i>Share</button>
  <div v-if="mainOpen" class="ds-menu" v-click-away="closeAll">

    <div v-if="!shareUrl">
      <div class="ds-section">Create a share link valid for:</div>
      <button class="ds-item" @click="mintToken(1)" :disabled="minting"><i class="mdi mdi-clock-outline me-2" style="color:#f1b44c;"></i>24 hours</button>
      <button class="ds-item" @click="mintToken(7)" :disabled="minting"><i class="mdi mdi-clock-outline me-2" style="color:#f1b44c;"></i>7 days</button>
      <button class="ds-item" @click="mintToken(30)" :disabled="minting"><i class="mdi mdi-clock-outline me-2" style="color:#f1b44c;"></i>30 days</button>
      <button class="ds-item" @click="mintToken(0)" :disabled="minting"><i class="mdi mdi-infinity me-2" style="color:#BFA164;"></i>No expiry</button>
      <div class="ds-divider"></div>
      <button class="ds-item" @click="showManage"><i class="mdi mdi-cog-outline me-2" style="color:#888;"></i>Manage share links…</button>
      <div v-if="mintError" class="ds-error">{{ mintError }}</div>
    </div>

    <div v-else>
      <div class="ds-section">Link ready — valid {{ activeExpiryLabel }}</div>
      <a class="ds-item" :href="emailHref"><i class="mdi mdi-email me-2" style="color:#4a8cf7;"></i>Email</a>
      <a class="ds-item" :href="whatsappHref" target="_blank" rel="noopener"><i class="mdi mdi-whatsapp me-2" style="color:#25D366;"></i>WhatsApp</a>
      <a class="ds-item" :href="smsHref"><i class="mdi mdi-message-text me-2" style="color:#f1b44c;"></i>SMS</a>
      <button class="ds-item" @click="copy"><i class="mdi" :class="copied ? 'mdi-check' : 'mdi-link-variant'" :style="copied?'color:#50C878':'color:#BFA164'" style="margin-right:8px;"></i>{{ copied ? 'Link copied!' : 'Copy link' }}</button>
      <div class="ds-divider"></div>
      <button class="ds-item ds-muted" @click="resetLink"><i class="mdi mdi-restart me-2" style="color:#888;"></i>New link…</button>
    </div>
  </div>

  <!-- Manage modal -->
  <div v-if="manageOpen" class="ds-overlay" @click.self="manageOpen=false">
    <div class="ds-modal">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h5 class="m-0 fw-bold">Share links for this document</h5>
        <button class="btn-close" @click="manageOpen=false"></button>
      </div>
      <div v-if="loadingLinks" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
      <div v-else-if="!links.length" class="text-muted text-center py-3" style="font-size:13px;">No share links yet.</div>
      <table v-else class="ds-table">
        <thead><tr><th>Created</th><th>Status</th><th>Expires</th><th>Views</th><th></th></tr></thead>
        <tbody>
          <tr v-for="l in links" :key="'l-'+l.id" :class="{'ds-r-revoked':l.status==='revoked','ds-r-expired':l.status==='expired'}">
            <td>
              <div>{{ fD(l.created_at) }}</div>
              <div class="ds-token" :title="l.token">{{ String(l.token).slice(0,10) }}…</div>
            </td>
            <td><span class="ds-pill" :class="'pill-'+l.status">{{ l.status.toUpperCase() }}</span></td>
            <td>{{ l.expires_at ? fD(l.expires_at) : '—' }}</td>
            <td>
              {{ l.view_count || 0 }}
              <div v-if="l.last_viewed_at" class="ds-sub">{{ fD(l.last_viewed_at) }}</div>
            </td>
            <td>
              <button v-if="l.status==='active'" class="btn btn-sm btn-outline-danger" @click="revoke(l)"><i class="mdi mdi-cancel"></i></button>
              <button v-if="l.status==='active'" class="btn btn-sm btn-outline-warning ms-1" @click="useExistingLink(l)"><i class="mdi mdi-share-variant"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-warning w-100 mt-3" @click="manageOpen=false">Done</button>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "DocShare",
  props: {
    title: { type: String, default: 'Document' },
    docRef: { type: String, default: '' },
    docType: { type: String, required: true }, // delivery_note | requisition | slaughter_sheet | payment_calc
    docId: { type: [Number, String], required: true },
    routePrefix: { type: String, default: '' } // e.g. /delivery-note ; if empty, we infer from docType
  },
  data(){ return {
    mainOpen:false, manageOpen:false, copied:false, minting:false, mintError:'',
    shareToken:'', activeExpiryDays:null,
    links:[], loadingLinks:false
  }; },
  computed: {
    routeBase(){
      if (this.routePrefix) return this.routePrefix;
      var m = { delivery_note:'/delivery-note', requisition:'/requisition', slaughter_sheet:'/slaughter-sheet', payment_calc:'/payment-calc' };
      return m[this.docType] || '';
    },
    shareUrl(){
      if (!this.shareToken) return '';
      var origin = typeof window !== 'undefined' ? window.location.origin : '';
      // Vue Router history mode (switched 2026-07-22) — no more #/ prefix
      return origin + this.routeBase + '/' + this.docId + '/print?t=' + this.shareToken;
    },
    activeExpiryLabel(){
      if (this.activeExpiryDays === 0) return 'with no expiry';
      if (this.activeExpiryDays === 1) return 'for 24 hours';
      if (this.activeExpiryDays) return 'for ' + this.activeExpiryDays + ' days';
      return '';
    },
    message(){
      var ref = this.docRef ? ' — ' + this.docRef : '';
      return this.title + ref + '\n\n' + this.shareUrl;
    },
    subject(){ return this.title + (this.docRef ? ' — ' + this.docRef : ''); },
    emailHref(){ return 'mailto:?subject=' + encodeURIComponent(this.subject) + '&body=' + encodeURIComponent(this.message); },
    whatsappHref(){ return 'https://wa.me/?text=' + encodeURIComponent(this.message); },
    smsHref(){ return 'sms:?body=' + encodeURIComponent(this.message); }
  },
  directives: {
    'click-away': {
      mounted(el, binding){
        el.__clickAway = function(ev){ if (!el.contains(ev.target)) binding.value(ev); };
        document.addEventListener('click', el.__clickAway);
      },
      unmounted(el){ document.removeEventListener('click', el.__clickAway); }
    }
  },
  methods: {
    toggleMain(){ this.mainOpen = !this.mainOpen; },
    closeAll(){ this.mainOpen = false; },
    fD(d){ if(!d)return''; try{ return new Date(d).toLocaleDateString(undefined,{day:'2-digit',month:'short',year:'numeric'}) }catch(e){return d} },
    resetLink(){ this.shareToken = ''; this.activeExpiryDays = null; this.copied = false; },
    async mintToken(days){
      this.minting = true; this.mintError = '';
      try {
        var r = await executeJson({ function:'createDocumentShareLink', userId: sessionStorage.getItem('userId'), docType: this.docType, docId: this.docId, expiresInDays: days || '' }, flocker);
        if (r.data && r.data.success) {
          this.shareToken = r.data.data.token;
          this.activeExpiryDays = days;
        } else {
          this.mintError = (r.data && r.data.message) || 'Could not create link.';
        }
      } catch(e){ this.mintError = 'Network error.'; }
      this.minting = false;
    },
    async copy(){
      try {
        await navigator.clipboard.writeText(this.shareUrl);
        this.copied = true;
        var self = this; setTimeout(function(){ self.copied = false; }, 1500);
      } catch(e){
        var ta = document.createElement('textarea'); ta.value = this.shareUrl; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); this.copied = true; setTimeout(()=>{this.copied=false;},1500); } catch(_){}
        document.body.removeChild(ta);
      }
    },
    async showManage(){
      this.mainOpen = false;
      this.manageOpen = true;
      this.loadingLinks = true;
      try {
        var r = await executeJson({ function:'listDocumentShareLinks', userId: sessionStorage.getItem('userId'), docType: this.docType, docId: this.docId }, flocker);
        if (r.data && r.data.success) this.links = r.data.data.links || [];
      } catch(e){}
      this.loadingLinks = false;
    },
    async revoke(l){
      if (!confirm('Revoke this share link? Anyone holding it will lose access immediately.')) return;
      try {
        var r = await executeJson({ function:'revokeDocumentShareLink', userId: sessionStorage.getItem('userId'), token: l.token }, flocker);
        if (r.data && r.data.success) { l.status = 'revoked'; l.revoked_at = new Date().toISOString(); }
      } catch(e){}
    },
    useExistingLink(l){
      this.shareToken = l.token;
      this.activeExpiryDays = l.expires_at ? Math.round((new Date(l.expires_at) - new Date()) / 86400000) : 0;
      this.manageOpen = false;
      this.mainOpen = true;
    }
  }
};
</script>

<style scoped>
.ds-wrap{position:relative;display:inline-block}
.ds-menu{position:absolute;top:calc(100% + 4px);right:0;background:#FFFFFF;border:1px solid #D8D2C2;border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.14);padding:6px;min-width:240px;z-index:1000}
.ds-section{font-size:10px;color:#888;text-transform:uppercase;letter-spacing:1px;padding:6px 10px 4px}
.ds-item{display:flex;align-items:center;padding:8px 12px;color:#1A1A1A;text-decoration:none;font-size:13px;border-radius:6px;cursor:pointer;background:transparent;border:none;width:100%;text-align:left}
.ds-item:hover{background:#F7F5F0;color:#1A1A1A}
.ds-item.ds-muted{color:#666;font-size:12px}
.ds-divider{height:1px;background:#E5E0D5;margin:6px 4px}
.ds-error{color:#B71C1C;font-size:11px;padding:6px 12px}
.ds-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);display:flex;align-items:flex-start;justify-content:center;padding:30px 16px;z-index:2000;overflow-y:auto}
.ds-modal{background:#FFFFFF;border:1px solid #D8D2C2;border-radius:12px;padding:20px;max-width:640px;width:100%;color:#1A1A1A}
.ds-table{width:100%;border-collapse:collapse;font-size:12px}
.ds-table th{background:#F7F5F0;color:#555;text-align:left;padding:6px 8px;font-size:10px;text-transform:uppercase;letter-spacing:.5px}
.ds-table td{padding:8px;border-bottom:1px solid #E5E0D5}
.ds-token{font-family:monospace;font-size:10px;color:#888}
.ds-sub{font-size:10px;color:#888}
.ds-r-revoked td,.ds-r-expired td{opacity:.55}
.ds-pill{font-size:9px;font-weight:700;padding:2px 8px;border-radius:10px;letter-spacing:.5px}
.ds-pill.pill-active{background:#C8E6C9;color:#1F6B1F}
.ds-pill.pill-expired{background:#E0DDD3;color:#777}
.ds-pill.pill-revoked{background:#FFCDD2;color:#B71C1C}
@media print { .ds-wrap, .ds-menu, .ds-overlay { display:none !important; } }
</style>
